<template>
    <v-container>
        <v-data-table
            :headers="headers"
            :items="desserts"
            :items-per-page="10"
            class="elevation-1"
        >
            <template v-slot:top>
                <v-col cols="4">
                    <v-select label="กลุ่มงานบริการ" :items="groups">
                </v-select>
                </v-col>
            </template>
           
        </v-data-table>
    </v-container>
  
</template>

<script>
export default {
    name: "Data2_2",
    data: () => ({
        groups: ["กลุ่มงาน A"],
        headers: [
            {text: 'วัน', value: 'day'},
            {text: 'วันที่', value: 'date'},
            {text: 'จำนวนทั้งหมด', value: 'total'},
            {text: 'จนท.นัดหมาย', value: 'appoint'},
            {text: '', value: 'percentAppoint'},
            {text: 'จนท.ปฏิเสธนัด', value: 'reject'},
            {text: '', value: 'percentReject'},
            {text: 'สมาชิกจองคิว', value: 'reserve'},
            {text: '', value: 'percentReserve'},
            {text: 'สมาชิกแจ้งยกเลิกนัด', value: 'cancel'},
            {text: '', value: 'percentCancel'},
            {text: 'สัดส่วนนัดหมาย:การจองคิว', value: 'ratio'}
            ],
        desserts: [
            {'day': 'จันทร์', 'date': '01/03/2021', 'total': 122, 'appoint': 19, 'percentAppoint': '15.57%', 'reject': 12, 'percentReject': '9.84%', 'reserve': 53, 'percentReserve': '43.44%', 'cancel': 38, 'percentCancel': '31.15%', 'ratio': '35.85%'},
            {'day': 'อังคาร', 'date': '02/03/2021', 'total': 112, 'appoint': 20, 'percentAppoint': '17.86%', 'reject': 18, 'percentReject': '16.07%', 'reserve': 47, 'percentReserve': '41.96%', 'cancel': 27, 'percentCancel': '24.11%', 'ratio': '42.55%'},
            {'day': 'พุธ', 'date': '03/03/2021', 'total': 171, 'appoint': 60, 'percentAppoint': '35.09%', 'reject': 4, 'percentReject': '2.34%', 'reserve': 88, 'percentReserve': '51.46%', 'cancel': 19, 'percentCancel': '11.11%', 'ratio': '68.18%'},
            {'day': 'พฤหัส', 'date': '04/03/2021', 'total': 97, 'appoint': 19, 'percentAppoint': '19.59%', 'reject': 19, 'percentReject': '19.59%', 'reserve': 37, 'percentReserve': '38.14%', 'cancel': 22, 'percentCancel': '22.68%', 'ratio': '51.35%'},
            {'day': 'ศุกร์', 'date': '05/03/2021', 'total': 122, 'appoint': 22, 'percentAppoint': '18.03%', 'reject': 27, 'percentReject': '22.13%', 'reserve': 48, 'percentReserve': '39.34%', 'cancel': 25, 'percentCancel': '20.49%', 'ratio': '45.83%'},
            {'day': 'เสาร์', 'date': '06/03/2021','total': 125, 'appoint': 27, 'percentAppoint': '21.60%', 'reject': 17, 'percentReject': '13.60%', 'reserve': 44, 'percentReserve': '35.20%', 'cancel': 37, 'percentCancel': '29.60%', 'ratio': '61.36%'},
            {'day': 'อาทิตย์', 'date': '07/03/2021', 'total': 145, 'appoint': 45, 'percentAppoint': '31.03%', 'reject': 9, 'percentReject': '6.21%', 'reserve': 59, 'percentReserve': '40.69%', 'cancel': 32, 'percentCancel': '22.07%', 'ratio': '76.27%'}
        ]
    })
}
</script>